import React from "react";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import IconButton from "@material-ui/core/IconButton";
import Card from "@material-ui/core/Card";
import useStyles from "../../../assets/cardStyles";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import { Link } from "react-router-dom";

export default function AddNewMenuCard(props) {
	const classes = useStyles();
	const handleClick = () => {};

	return (
		<Card className={classes.root}>
			<CardMedia
				className={classes.media}
				image={
					"https://firebasestorage.googleapis.com/v0/b/milagritoapp.appspot.com/o/Menu%2F46f65666-47a1-490f-be99-e9c26f691085AROS.jpg?alt=media&token=b2068a61-be4d-4b94-a58c-0d3583666ca8"
				}
				title="placeholder"
			/>
			<CardHeader title="Agregar nuevo" style={{ textAlign: "center" }} />
			<CardContent style={{ textAlign: "center" }}>
				<Link to="/add">
					<IconButton className={classes.addMore} aria-label="add new Menu" onClick={handleClick}>
						<AddCircleOutlineIcon style={{ fontSize: "2em" }} />
					</IconButton>
				</Link>
			</CardContent>
		</Card>
	);
}
